var burgerMenuElement = document.querySelector(".burger-menu");
var bodyElement = document.querySelector("body");

function handleBurgerClick() {
  // https://developer.mozilla.org/fr/docs/Web/API/Element/classList
  bodyElement.classList.toggle("mobile-menu-opened");
}

burgerMenuElement.addEventListener("click", handleBurgerClick);
